var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWechatOp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 32,
    viewBox: "0 0 48 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0761 20.242C18.9131 20.3246 18.7295 20.3724 18.5344 20.3724C18.0826 20.3724 17.69 20.123 17.4839 19.7537L17.4049 19.5804L14.1162 12.3355C14.0807 12.2568 14.0587 12.1676 14.0587 12.0809C14.0587 11.747 14.3284 11.4765 14.661 11.4765C14.7959 11.4765 14.9209 11.5214 15.0213 11.5964L18.9022 14.3704C19.1857 14.5564 19.5245 14.6656 19.8886 14.6656C20.106 14.6656 20.3132 14.625 20.5065 14.5544L38.757 6.40003C35.4856 2.52963 30.0979 0 24.0011 0C14.0241 0 5.93689 6.76588 5.93689 15.1126C5.93689 19.6659 8.37006 23.7649 12.1786 26.5355C12.484 26.7545 12.6841 27.1142 12.6841 27.5203C12.6841 27.6546 12.6554 27.7771 12.6205 27.9051C12.3163 29.0442 11.8294 30.8683 11.8068 30.9538C11.7688 31.0967 11.7096 31.2461 11.7096 31.3956C11.7096 31.7295 11.979 32 12.3121 32C12.4426 32 12.5495 31.9512 12.6597 31.8875L16.6144 29.5953C16.9119 29.4232 17.2268 29.3162 17.574 29.3162C17.7585 29.3162 17.9369 29.345 18.1046 29.3964C19.9495 29.9292 21.9401 30.2252 24.0012 30.2252C33.9776 30.2252 42.0659 23.4589 42.0659 15.1126C42.0659 12.5845 41.3196 10.2036 40.008 8.10918L19.2085 20.1654L19.0761 20.242Z",
    fill: "#1AAD19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWechatOp);
export default __webpack_public_path__ + "static/media/wechat-op.62007a51621414f6f9f41524e5fd3530.svg";
export { ForwardRef as ReactComponent };